export const ClientKeys = {
	all: ["client"] as const,
};
